
export default {
  props: {
    tableData: {
      type: Array,
      default: [],
    },
    tableColumns: {
      type: Array,
      default: [],
    },
    operateWith: {
      type: String,
      default: "100%",
    },
    selectionShow: {
      type: Boolean,
      default: false,
    },
    handleShow: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    saveUnitData(row, idx) {
      this.tableData[idx] = row
      localStorage.setItem('unit', JSON.stringify(this.tableData))
    }
  },
};
